import { useFeature } from '@/lib/hooks/useFeature';
import { FeatureFlags } from '@/lib/types';
import React, { PropsWithChildren } from 'react';

interface FeatureProps extends PropsWithChildren {
  flag: keyof FeatureFlags;
  inverse?: boolean;
  disabled?: React.ReactNode;
}

export const Feature: React.FunctionComponent<FeatureProps> = ({ flag, inverse, children, disabled }) => {
  let isEnabled = useFeature(flag as string);
  if (inverse) {
    isEnabled = !isEnabled;
  }

  if (isEnabled) {
    return <>{children}</>;
  }

  return <>{disabled}</>;
};
